import React from 'react';
import { Page, Flex } from 'components/base/layout-components';

import ProjectExtended from '../projects/ProjectsApi/ProjectExtended';
import { SUMMARY_PERIODS } from '../projects/ProjectsApi/projects.consts';
import PulseRetroEmptyState from './PulseRetroEmptyState';
import {
  currentIterationSelector,
  KANBAN_TYPES
} from 'state/selectors/iterations-picker';
import useOpenIterationSummary from '../../hooks/useOpenIterationSummary';
import useFetchSummaryData from 'components/IterationSummary/useFetchSummaryData';
import IterationSummarySlide from 'components/IterationSummary';
import { useSelector } from 'react-redux';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { teamProjectSelector } from 'state/selectors/projects';

const getIterationProviderId = (pdtProjectId, iteration) => {
  if (!iteration) return null;

  const { type = '', end_date, provider_id, name } = iteration;
  if (KANBAN_TYPES.includes(type.toLowerCase()) || !provider_id) {
    const endDateYear = end_date.split('-')[0];
    const week = name.replace(/\D/g, '').trim();
    return `${pdtProjectId}-${endDateYear}-${week}`;
  }
  return provider_id;
};

const RetroactivePulse = ({
  pdtIteration, // conditional controlled pdt-iteration
  controlledTeam = null,
  duration = SUMMARY_PERIODS.single_iteration,
  onClickTrendIteration = null,
  isLoading = false
}) => {
  const isControlled = pdtIteration !== undefined;
  const currentIteration = useSelector(currentIterationSelector);

  const currentTeam = useSelector(selectedTeamSelector);
  const selectedTeam = controlledTeam || currentTeam;
  const selectedTeamProject = useSelector(state =>
    teamProjectSelector(state, selectedTeam?.id)
  );

  const pdtProjectId = selectedTeamProject?.pdt_project_id;
  const iterationProviderId = getIterationProviderId(
    pdtProjectId,
    isControlled ? pdtIteration : currentIteration
  );
  const { shouldShowIterationSummary, isIterationSummaryInQs } =
    useOpenIterationSummary();

  const iterationSummary = useFetchSummaryData({
    teamId: selectedTeam?.id,
    iterationProviderId
  });

  return (
    <Flex grow='1' padding='small'>
      {shouldShowIterationSummary && (
        <IterationSummarySlide
          isIterationSummaryOpen={isIterationSummaryInQs}
          iterationSummary={iterationSummary}
        />
      )}
      <Page key={`${pdtProjectId}-${iterationProviderId}`}>
        <ProjectExtended
          pdtProjectId={pdtProjectId}
          duration={duration}
          currentSelectedIteration={{
            ...(isControlled
              ? { ...pdtIteration }
              : {
                  start: currentIteration?.start_date,
                  end: currentIteration?.end_date,
                  provider_id: iterationProviderId
                })
          }}
          showTopBar={false}
          EmptyStateComponent={PulseRetroEmptyState}
          isRetrospectView={true}
          iterationSummary={iterationSummary}
          onClickTrendIteration={onClickTrendIteration}
          isLoading={isLoading}
        />
      </Page>
    </Flex>
  );
};

export default RetroactivePulse;
